import React, { Component } from 'react'
import Link from '../utils/link'

class WhyUsList extends Component {

  render() {

    let { title, list, button } = this.props

    // check if button contains #
    let isHash = button && button.url && button.url.indexOf('#') > -1

    // buttonClick scroll to hash
    const buttonClick = (e) => {
      e.preventDefault()
      let hash = e.target.href.split('#')[1]
      let el = document && document.getElementById(hash)
      if (el) {
        // scroll to element - 100px
        window && window.scroll({
          top: el.offsetTop - 80,
          left: 0,
          behavior: 'smooth'
        })
      }
    }


    return (
      <section className='why-us-list'>
        <div className='why-us-list__inner'>
          <div className='why-us-list__content'>
            <div className='why-us-list__heading'>
              <h3>{ title }</h3>
            </div>
            <div className='why-us-list__details'>
              { list && 
                <div className='why-us-list__list'>
                  <ol>
                    {list.map((el, i) => (
                      <li key={i}>
                        <div className='title-container'>
                          <div className='number'>
                          0{ i + 1 }
                          </div>

                          <div className='title'>
                            { el.title }
                          </div>

                        </div>
                        <div className='content' dangerouslySetInnerHTML={{ __html: el.content }} />
                      </li>
                    ))}
                  </ol>
                </div>
              }
            </div>
            { button?.url && <Link className='btn' to={button.url} onClick={(e) => isHash ? buttonClick(e) : null}>{button.title}</Link> }
          </div>
        </div>
      </section>
    )
  }
}

export default WhyUsList
